var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0043 19C18.5349 19 23 13.6588 23 12C23 10.3325 18.5177 5 12.0043 5C5.56798 5 1 10.3325 1 12C1 13.6588 5.56798 19 12.0043 19ZM12.0043 16.5509C9.50175 16.5509 7.51344 14.4752 7.4963 12C7.48773 9.45533 9.50175 7.45782 12.0043 7.45782C14.4982 7.45782 16.5123 9.46402 16.5123 12C16.5123 14.4752 14.4982 16.5509 12.0043 16.5509ZM12.0129 13.6588C12.9127 13.6588 13.6584 12.9032 13.6584 12C13.6584 11.0881 12.9127 10.3325 12.0129 10.3325C11.0958 10.3325 10.3502 11.0881 10.3502 12C10.3502 12.9032 11.0958 13.6588 12.0129 13.6588Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-view.2e01dee3944f7ac434992f4e9f3ddd5f.svg";